import type { Location } from 'react-router-dom'

interface RouterLike {
  state: { location: Location }
  subscribe(fn: (state: { location: Location }) => void): () => void
}

// The current history entry, mirrored from the router so useHistoryState can
// subscribe per key: reading useLocation re-rendered every SetBlock and
// MemberFacepile on any navigation (each dialog open is one), past their memo.

let current: Location | null = null
const listeners = new Set<() => void>()

export function connectHistoryUiStore(router: RouterLike) {
  current = router.state.location
  router.subscribe(state => {
    if (state.location === current) return
    current = state.location
    listeners.forEach(l => l())
  })
}

export function subscribeHistoryUi(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function currentLocation(): Location | null {
  return current
}
